import { render, staticRenderFns } from "./RdmBanner.vue?vue&type=template&id=502fdc66&scoped=true&"
import script from "./RdmBanner.vue?vue&type=script&lang=ts&"
export * from "./RdmBanner.vue?vue&type=script&lang=ts&"
import style0 from "./RdmBanner.vue?vue&type=style&index=0&id=502fdc66&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "502fdc66",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBanner } from 'vuetify/lib/components/VBanner';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBanner,VIcon})
